var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDots = function SvgDots(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 8.33325C5.58714 8.33325 6.33333 9.07944 6.33333 9.99992C6.33333 10.9204 5.58714 11.6666 4.66667 11.6666C3.74619 11.6666 3 10.9204 3 9.99992C3 9.07944 3.74619 8.33325 4.66667 8.33325Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 8.33325C17.2538 8.33325 18 9.07944 18 9.99992C18 10.9204 17.2538 11.6666 16.3333 11.6666C15.4129 11.6666 14.6667 10.9204 14.6667 9.99992C14.6667 9.07944 15.4129 8.33325 16.3333 8.33325Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1667 9.99992C12.1667 9.07944 11.4205 8.33325 10.5 8.33325C9.57952 8.33325 8.83333 9.07944 8.83333 9.99992C8.83333 10.9204 9.57953 11.6666 10.5 11.6666C11.4205 11.6666 12.1667 10.9204 12.1667 9.99992Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDots);
export default ForwardRef;